import { Helmet } from 'react-helmet-async';
// mantine
import { Loader } from '@mantine/core';
// components
import Header from '@/components/Header';
import PageContainer from '@/components/Layout/components/PageContainer';
import { useWidgetsContent } from '@/pages/Widgets/Widgets.hook';
// utils

const Widgets = () => {
    const { content, isLoading } = useWidgetsContent();

    return (
        <>
            <Helmet>
                <title>NEWO - Widgets</title>
            </Helmet>
            <Header title="Widgets" />
            <PageContainer>
                {isLoading ? (
                    <div className="flex items-center justify-center py-20">
                        <Loader />
                    </div>
                ) : undefined}

                <div className="relative h-[90vh]">{content}</div>
            </PageContainer>
        </>
    );
};

export default Widgets;
